<template>
  <div>
    <b-modal
      :title="$t('modal.products.title_add')"
      :id="modalId"
      :ok-title="$t('modal.products.ok_button')"
      :cancel-title="$t('modal.general.cancel_button')"
      @show="resetForm"
      @ok="verifyForm">
      <b-form @submit.prevent="verifyForm">

        <!--PRODUCT NAME-->
        <b-form-group
          id="product-name-group"
          :label="$t('form.products.name_label')"
          :invalid-feedback="invalidName"
          :state="stateName"
          label-for="product-name"
        >
          <b-form-input
            id="product-name"
            v-model="productName"
            :state="stateNameInput"
            :placeholder="$t('form.products.name_field')"
          ></b-form-input>
        </b-form-group>

        <!--PRODUCT PRICE-->
        <b-form-group
          id="product-price-group"
          :label="$t('form.products.sell_price_label')"
          :invalid-feedback="invalidPrice"
          :state="statePrice"
          label-for="product-price"
        >
          <b-form-input
            id="product-price"
            v-model="productPrice"
            :state="statePriceInput"
            :placeholder="$t('form.products.sell_price_field')"
          ></b-form-input>
        </b-form-group>

        <!--PRODUCT AMOUNT-->
        <b-form-group
          id="product-amount-group"
          :label="$t('form.products.amount_label', {max_amount: maxAmount})"
          :invalid-feedback="invalidAmount"
          :state="stateAmount"
          label-for="product-amount"
        >
          <b-form-input
            id="product-amount"
            v-model="productAmount"
            :state="stateAmountInput"
            :placeholder="$t('form.products.amount_field')"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import { required, numeric, between, maxLength } from 'vuelidate/lib/validators'
  import { decimalValidator, noQuotesValidator } from '@base/customValidators'
  import { PRODUCT_NAME_MAX_LENGTH } from '@user/configs'

  export default {
    name: 'BulkCreateProductModal',

    data () {
      return {
        productName: '',
        productPrice: '',
        productAmount: '',
        maxAmount: 0,
        loading: false,
      }
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
      productsList: {
        type: Array,
        required: true
      }
    },

    validations () {
      return {
        productName: {
          required,
          maxLength: maxLength(PRODUCT_NAME_MAX_LENGTH),
          noQuotesValidator,
        },
        productPrice: {
          required,
          decimal: decimalValidator,
        },
        productAmount: {
          required,
          numeric,
          between: between(1, this.maxAmount)
        }
      }
    },

    computed: {

      // VALIDATIONS
      stateNameInput () {
        return this.$v.productName.$error ? false : null
      },
      stateName () {
        return (!this.$v.productName.$error)
      },
      invalidName () {
        if (this.$v.productName.$error) {
          if (!this.$v.productName.required)
            return this.$t('validation.required', { field: this.$t('form.products.name_field') })
          else if (!this.$v.productName.maxLength)
            return this.$t('validation.max_length', {
              field: this.$t('form.products.sell_price_field'),
              maxLength: this.$v.productName.$params.maxLength.max
            })
          else if (!this.$v.productName.noQuotesValidator)
            return this.$t('validation.quotes_not_allowed', { field: this.$t('form.products.name_field') })
        }
        return null
      },

      statePriceInput () {
        return this.$v.productPrice.$error ? false : null
      },
      statePrice () {
        return (!this.$v.productPrice.$error)
      },
      invalidPrice () {
        if (this.$v.productPrice.$error) {
          if (!this.$v.productPrice.required)
            return this.$t('validation.required', { field: this.$t('form.products.sell_price_field') })
          else if (!this.$v.productPrice.decimal)
            return this.$t('validation.decimal', {field: this.$t('form.products.sell_price_field')})
        }
        return null
      },

      stateAmountInput () {
        return this.$v.productAmount.$error ? false : null
      },
      stateAmount () {
        return (!this.$v.productAmount.$error)
      },
      invalidAmount () {
        if (this.$v.productAmount.$error) {
          if (!this.$v.productAmount.required)
            return this.$t('validation.required', { field: this.$t('form.products.amount_field') })
          else if (!this.$v.productAmount.numeric)
            return this.$t('validation.numeric', { field: this.$t('form.products.amount_field') })
          else if (!this.$v.productAmount.between)
            return this.$t('validation.between', {
              field: this.$t('form.product.amount_field'),
              min_amount: this.$v.productAmount.$params.between.min,
              max_amount: this.$v.productAmount.$params.between.max,
            })
        }
        return null
      },
    },

    methods: {
      resetForm () {
        this.$v.$reset()
        this.productName = ''
        this.productPrice = ''
        this.productAmount = ''
      },

      verifyForm (bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.$touch()
        if (this.$v.$invalid)
          return
        this.generateProducts()
      },

      updateMaxAmount (products) {
        this.maxAmount = products.filter(product => !product.name || !product.sellPrice).length
      },

      generateProducts () {
        for (let productIndex = 1; productIndex <= this.productAmount; productIndex++) {
          const oldProductObj = this.productsList.find(obj => !obj.name || !obj.sellPrice)
          const productObj = {
            productSheet: oldProductObj.productSheet,
            number: oldProductObj.number,
            name: this.productName,
            sellPrice: this.productPrice,
          }
          Object.assign(oldProductObj, productObj)
        }
        this.updateMaxAmount(this.productsList)
        this.$emit('productsGenerated', this.productsList)
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalId)
        })
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('notifications.title.success'),
          text: this.$t('notifications.text.products.success_products_generated')
        })
      },
    }
  }
</script>

<style>

</style>
